<template>
  <div class="tool-box">
    <el-tooltip class="item" effect="dark" content="重置视图" placement="left">
      <div class="tool-item" @click="resetView">
        <i class="el-icon-full-screen"></i>
      </div>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" content="清除绘制" placement="left">
      <div class="tool-item" @click="clearMap">
        <i class="el-icon-delete-solid"></i>
      </div>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" content="测距" placement="left">
      <div class="tool-item" @click="startMeasureLine">
        <i class="iconfont icon-ceju"></i>
      </div>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" content="测面积" placement="left">
      <div class="tool-item" @click="startMeasureArea">
        <i class="iconfont icon-cemianji"></i>
      </div>
    </el-tooltip>
  </div>
</template>
<script>
export default {
  data() {
    return {
      windSwitch: false,
    };
  },
  methods: {
    resetView() {
      if (this.$listeners["reset-view"]) {
        this.$emit("reset-view");
      }
    },
    toggleWind() {
      this.windSwitch = !this.windSwitch;
      if (this.$listeners["wind"]) {
        this.$emit("wind", this.windSwitch);
      }
    },
    startMeasureLine() {
      if (this.$listeners["measure-line"]) {
        this.$emit("measure-line");
      }
    },
    startMeasureArea() {
      if (this.$listeners["measure-area"]) {
        this.$emit("measure-area");
      }
    },
    clearMap() {
      if (this.$listeners["clear-map"]) {
        this.$emit("clear-map");
      }
    },
  },
};
</script>
<style lang="less" scoped>
.tool-box {
  position: absolute;
  left: 0.7vw;
  top: 3vh;
  display: flex;
  z-index: 1001;
  flex-direction: column;
}
.tool-item {
  outline: medium;
  cursor: pointer;
  width: 1.3vw;
  height: 1.3vw;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.5vw;
  border-radius: 0.2vw;
  background: rgba(0, 0, 0, 0.6);
  border: 0.01vw solid #434343;
  i {
    color: #bfbfbf;
    font-size: 1.04vw;
  }
}
.tool-item:hover {
  background: rgba(0, 245, 245, 0.15);
  i {
    color: #00f5f5;
  }
}
.active {
  background: rgba(0, 245, 245, 0.15);
  i {
    color: #00f5f5;
  }
}
</style>